module.exports = __webpack_public_path__ + "img/people-outlined.139c44b1.svg";